<template>
  <b-modal
      ref="add-coins-modal"
      size="lg"
      :title="$t(title.toString())"
  >
    <b-form>

      <b-form-group id="input-group-1" :label="$t('form.label.amount')" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.amount"
            @keypress="isRestricted($event)"
            :state="!$v.form.amount.$dirty ? null :(!$v.form.amount.$error)"
            :placeholder="$t('form.placeholder.enter_amount')"
            required
        ></b-form-input>
        <p v-if="$v.form.amount.$dirty && !$v.form.amount.required" class="text-danger">{{ $t('coins.errors.required') }}</p>
        <p v-if="$v.form.amount.$dirty && !$v.form.amount.server" class="text-danger">{{ $t('coins.errors.limit') + ' ' + serverError['manualCreditLimit'] }}</p>
      </b-form-group>

      <b-form-group id="input-group-2" :label="$t('form.label.comment')" label-for="input-2">
        <b-form-textarea
            id="input-2"
            v-model="form.comment"
            :state="!$v.form.comment.$dirty ? null :(!$v.form.comment.$error)"
            required
        ></b-form-textarea>
        <p v-if="$v.form.comment.$dirty && !$v.form.comment.required" class="text-danger">{{ $t('coins.errors.required') }}</p>
      </b-form-group>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import alertify from "alertifyjs";
import {formatStringToFloat} from "../../../filters";

const validateFromServer = () => function (value) {
  if (!this.serverError) return true;
  return formatStringToFloat(value) <= this.serverError['manualCreditLimit'];
}

export default {
  data() {
    return {
      title: null,
      groups: [],
      serverError: null,
      form: {
        amount: null,
        currency: null,
        comment: null,
      },
    }
  },
  validations: {
    form: {
      amount: {
        required,
        server: validateFromServer()
      },
      comment: {
        required
      }
    }
  },
  mounted() {
    this.openModal();
  },
  computed: {
    busy: function () {
      return this.$store.getters['players/isBusy'];
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('players/manualCredit', {...this.form, amount: formatStringToFloat(this.form.amount), playerId: this.$parent.playerId})
        .then(
            () => {
              setTimeout(() => this.$parent.getPlayer(),2000);
              this.hideModal();
              alertify.success('Manual credit success.');
            }
        ).catch( err => {
          this.serverError = err.response.data.parameters;
        })
      }
    },
    openModal() {
      this.$refs['add-coins-modal'].show();
    },
    hideModal() {
      this.$refs['add-coins-modal'].hide();
    },
    isRestricted: function(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // 0-9 and . are allowed
      if (charCode !== 44 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
